// extracted by mini-css-extract-plugin
module.exports = {"ul":"TemplateThumbnails_ul__SvSWq","li":"TemplateThumbnails_li__uIm_H"};